import React, { ReactElement, useCallback, useEffect, useState } from "react";
import { Modal, Divider, Spin, message } from "antd";
const { confirm } = Modal;
import "./index.scss";
import { AddressList, EditAddress, DelAddress } from "../../../api/personal";
import { SvgIcon } from "../../../components/SvgIcon";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Address4Personal from "../../../components/Modal/Address/Address4Personal.tsx";
const Address: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [urlSearchParams] = useSearchParams();
  const [addressList, setAddressList] = useState<Array<Address>>([]);
  const [modalInstance, setModalInstance] = useState(false);
  const [addressInfo, setAddressInfo] = useState<Address | null>(null);
  const { t } = useTranslation();
  const [spinning, setSpinning] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchAddressList = useCallback(async () => {
    setSpinning(true);
    const res = await AddressList();
    setSpinning(false);
    if (res.code === 0) {
      setAddressList((res.data as Array<Address>) || []);
      // setAddressList([])
      return;
    }
    messageApi.error(res.msg);
  }, []);

  useEffect(() => {
    fetchAddressList();
  }, [urlSearchParams.get("randomKey")]);

  const submitAction4Btn = useCallback(async (params) => {
    const res = await EditAddress(params);
    if (res.code === 0) {
      fetchAddressList();
    }
  }, []);

  const editItem = (item: Address) => {
    setModalInstance(true);
    setAddressInfo(item);
  };

  const delItem = useCallback(async (item: Address) => {
    confirm({
      title: `${t("删除")} ${t("收件地址")}`,
      okText: `${t("删除")}`,
      okType: "danger",
      className: "confirm-ok-button",
      cancelText: `${t("取消")}`,
      onOk() {
        // console.log('OK');
        return DelAddress({ id: item.id }).then((res) => {
          if (res.code === 0) {
            // fetchAddressList();
            navigate(
              `${location.pathname}?randomKey=${Math.random()
                .toString(32)
                .slice(2)}`
            );
          }
        });
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  }, []);
  return (
    <section className="address-wrapper">
      {contextHolder}
      {addressList.length !== 0 ? (
        <div className="list-wrapper">
          {addressList.map((item) => (
            <div className="address-item" key={item.id}>
              <div className="title-name-wrapper">
                <div className="text-wrapper">
                  <div className="title">{t("收件地址")}:</div>
                  <div
                    className="value"
                    style={{ fontWeight: 600, color: `var(--kx-text-1)` }}
                  >{`${item.province}${item.city}${item.area}${item.detail_address}`}</div>
                </div>
                <div className="btn-wrapper">
                  <div className="btn" onClick={() => editItem(item)}>
                    <SvgIcon icon="icon-bianji" width={16} height={16} />
                    {t("编辑")}
                  </div>
                  <Divider type="vertical" />
                  <div className="btn" onClick={() => delItem(item)}>
                    {" "}
                    <SvgIcon icon="icon-shanchu" width={16} height={16} />
                    {t("删除")}
                  </div>
                </div>
              </div>
              <div className="text-wrapper">
                <div className="title">{t("收件人姓名")}:</div>
                <div className="value">
                  {item.contact_person_name ? item.contact_person_name : "-"}
                </div>
              </div>
              <div className="text-wrapper">
                <div className="title">{t("收件人手机号")}:</div>
                <div className="value">
                  {item.contact_telephone ? item.contact_telephone : "-"}
                </div>
              </div>
              <div className="text-wrapper">
                <div className="title">{t("收件人邮箱")}:</div>
                <div className="value">{item.email ? item.email : "-"}</div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-content" style={{ marginTop: "1.583rem" }}>
          <SvgIcon icon="icon-wuliebiao" />
          {t("暂无地址")}
        </div>
      )}
      {modalInstance && (
        <Address4Personal
          hiddenModal={() => setModalInstance(false)}
          title={t("编辑收件地址")}
          submitAction={(params) => submitAction4Btn(params)}
          addressInfo={addressInfo}
        />
      )}
      {spinning && (
        <div className="spin-wrapper">
          <Spin size="large" spinning={spinning} />
        </div>
      )}
    </section>
  );
};

export default Address;
